import { render } from "./CreateNewPlant.vue?vue&type=template&id=19fd69ac"
import script from "./CreateNewPlant.vue?vue&type=script&lang=js"
export * from "./CreateNewPlant.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__